import { QuillWrite02Icon } from '@hugeicons-pro/core-stroke-rounded';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Fab } from '@/components/gluestack/fab';
import { useTabBarProgress } from '@/components/layout/AnimatedTabBar';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';

interface IFeedCreatePostFabProps {
  onPress: () => void;
}

const AnimatedFab = Animated.createAnimatedComponent(Fab);

export function FeedCreatePostFab({ onPress }: IFeedCreatePostFabProps) {
  const tabBarProgress = useTabBarProgress();
  const { bottom: safeAreaBottom } = useSafeAreaInsets();

  const animatedStyle = useAnimatedStyle(() => {
    const progress = tabBarProgress?.value ?? 1;

    return {
      bottom: 16 + safeAreaBottom * (1 - progress),
    };
  }, [safeAreaBottom, tabBarProgress]);

  return (
    <AnimatedFab
      size="lg"
      className="bg-primary-500 hover:bg-primary-700 active:bg-primary-800"
      style={animatedStyle}
      onPress={onPress}>
      <HugeIconsWrapper icon={QuillWrite02Icon} className="text-white" />
    </AnimatedFab>
  );
}
